<template>
  <div class="authorization">
      <input type="text" v-model="authorization" @blur="updateAuthorization">
  </div>
</template>

<script>

export default {
    name: 'Authorization',
    data() {
      return {
        authorization: localStorage.getItem('authorization') || ''
      }
    },
    methods: {
      updateAuthorization() {
        if (this.authorization.length === 0) return;
        
        localStorage.setItem('authorization', this.authorization)
        
        window.location.href = '/';
      }
    }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/Authorization.vue